export const averageTimeOnArticle = {
  analysisType: 'average',
  eventCollection: 'kb.page.leave',
  key: 'averageTimeOnArticle',
  targetProperty: 'time.time_on_page',
}
